export default "__VITE_ASSET__BK$iBkq$__"